import { Catalog } from "@p0security/shared/types/catalog";
import { RecursiveReadonly } from "@p0security/shared/types/util";
import { createContext } from "react";

export const CatalogContext = createContext<RecursiveReadonly<Catalog>>({
  risks: {},
  privileges: { aws: {}, gcp: {}, k8s: {}, workspace: {} },
});
